<div *ngIf="(currentMenu$ | async) as currentMenu">
  <div *ngIf="currentMenu === menuOptions.CONTROL_POINT">
    <app-slide-menu-control-points></app-slide-menu-control-points>
  </div>
  <div *ngIf="currentMenu === menuOptions.EVENT">
    <app-slide-menu-event [allEvents]="allEvents"></app-slide-menu-event>
  </div>
  <div *ngIf="currentMenu === menuOptions.DEVICES">
    <app-seismograph-devices></app-seismograph-devices>
  </div>
</div>